import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { checkActivateAccount } from "services/user/userService";
import { FaSignInAlt, FaCheckCircle } from "react-icons/fa";
import "./VerifyEmail.scss";
import { PacmanLoader } from "react-spinners";

const VerifyEmail = () => {
  const [statusMessage, setStatusMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false); // Trạng thái thành công
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const activateAccount = async () => {
      try {
        // Lấy verify-token từ URL
        const params = new URLSearchParams(location.search);
        const verifyToken = params.get("verify-token");
        if (!verifyToken) {
          setStatusMessage(
            "Không tìm thấy token xác minh. Vui lòng kiểm tra lại."
          );
          return;
        }
        setIsLoading(true);
        // Gọi API kích hoạt tài khoản
        const response = await checkActivateAccount(verifyToken);
        setIsSuccess(true); // Đặt trạng thái thành công
        setStatusMessage("Tài khoản của bạn đã được kích hoạt thành công!");
      } catch (error) {
        if (error.message === "Request failed with status code 400") {
          setStatusMessage("Bạn đã kích hoạt tài khoản trước đó.");
        } else {
          setStatusMessage("Đã xảy ra lỗi khi kích hoạt tài khoản.");
        }
      } finally {
        setIsLoading(false);
      }
    };

    activateAccount();
  }, [location]);

  return (
    <div className="verify-email-container">
      {isSuccess && <FaCheckCircle className="success-icon" />} {/* Icon dấu tích */}
      <h2>Xác minh tài khoản</h2>
      <p>{statusMessage}</p>
      <div
        className="login-link"
        onClick={() => navigate("/login")} // Điều hướng về trang đăng nhập
      >
        <FaSignInAlt size={20} />
        <span>Đăng nhập ngay</span>
      </div>
      {isLoading && (
        <div className="modal">
          <div className="modal-content_loading">
            <PacmanLoader color="#5e2e86" />
          </div>
        </div>
      )}
    </div>
  );
};

export default VerifyEmail;
